export default "__VITE_ASSET__1951233b__"